module.exports = __webpack_public_path__ + "img/Flunder_5.fddefe89.jpg";